// extracted by mini-css-extract-plugin
export default {"virtualTable":"VirtualizedTable_virtualTable__snE64"};